import { formatDateTime } from "./basic.table"

// Shows the comments (messages) of a ticket in chronological order. They are read only here,
// the API of the ticket plugin only creates them in game.
const TicketComments = ({ comments }) => {
    const sorted = [...(comments === undefined || comments === null ? [] : comments)]
        .sort((a, b) => (a.created || 0) - (b.created || 0))

    return (
        <div className="card card-primary">
            <div className="card-header">
                <h3 className="card-title">Nachrichten ({sorted.length})</h3>
            </div>
            <div className="card-body">
                { sorted.length === 0 ?
                    <p className="text-muted mb-0">Zu diesem Ticket wurde noch keine Nachricht geschrieben.</p>
                :
                    <ul className="list-group list-group-flush">
                        { sorted.map((comment, index) => (
                            <li className="list-group-item" key={comment.id === undefined ? index : comment.id}>
                                <div className="d-flex justify-content-between">
                                    <strong>{comment.author_name}</strong>
                                    <span className="text-muted">
                                        {comment.created_formatted || formatDateTime(comment.created)}
                                    </span>
                                </div>
                                <div style={{ whiteSpace: "pre-wrap" }}>{comment.comment}</div>
                            </li>
                        ))}
                    </ul>
                }
            </div>
        </div>
    )
}

export default TicketComments
